import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import thunk from "redux-thunk";
import { connectRouter, routerMiddleware, push } from "connected-react-router";
import { createBrowserHistory } from "history";
import { alertReducer } from "../actions/alert-actions";
import { trackReducer } from "../actions/track-actions";
import { pageReducer } from "../actions/page-actions";
import { userReducer } from "../actions/user-actions";
import { filesReducer } from "../actions/file-actions";
import { peopleReducer } from "../actions/people-actions";
import { groupsReducer } from "../actions/group-actions";
import { messageReducer } from "../actions/message-actions";
import { escalationReducer } from "../actions/escalation-actions";
import { pushNotificationsReducer } from "../actions/push-notification-actions";
import { inAppNotificationsReducer } from "../actions/in-app-notification-actions";
import { embedNotificationsReducer } from "../actions/embed-notification-actions";

export const routerHistory = createBrowserHistory({ basename: "/" });
export const store = configureStore(routerHistory);

function configureStore(routerHistory, initialState) {
  const middleware = [thunk, routerMiddleware(routerHistory)];

  const reducers = {
    alert: alertReducer,
    files: filesReducer,
    groups: groupsReducer,
    overview: trackReducer,
    page: pageReducer,
    people: peopleReducer,
    user: userReducer,
    message: messageReducer,
    escalation: escalationReducer,
    pushNotifications: pushNotificationsReducer,
    inAppNotifications: inAppNotificationsReducer,
    embedNotifications: embedNotificationsReducer,
    router: connectRouter(routerHistory),
  };

  const enhancers = [];
  const windowIfDefined = typeof window === "undefined" ? null : window;
  if (windowIfDefined && windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__) {
    enhancers.push(windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__());
  }

  return createStore(
    combineReducers(reducers),
    initialState,
    compose(applyMiddleware(...middleware), ...enhancers)
  );
}

export function dispatch(type, payload, delay) {
  if (delay) setTimeout(() => store.dispatch({ type: type, payload: payload }));
  else store.dispatch({ type: type, payload: payload });
}

export function appState() {
  return store.getState();
}

/** Returns the active auth token — HGS session first, ParishSoft embed token as fallback. */
export function getAuthToken() {
  return store.getState().user?.token || localStorage.getItem("ParishSoftToken") || null;
}
